import BusinessIcon from '@material-ui/icons/Business';
import InstanceCreate from './InstanceCreate';
import InstanceEdit from './InstanceEdit';
import InstanceList from './InstanceList';
import InstanceShow from './InstanceShow';

const pages = {
    list: InstanceList,
    create: InstanceCreate,
    edit: InstanceEdit,
    show: InstanceShow,
    icon: BusinessIcon,
};

export default pages;